'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002459 from "./presto.-Two-Factor-Auth-View$$anon$59.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002461 from "./presto.-Two-Factor-Auth-View$$anon$61.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002463 from "./presto.-Two-Factor-Auth-View$$anon$63.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002465 from "./presto.-Two-Factor-Auth-View$$anon$65.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024 from "./presto.types$-Two-Factor-Auth-Usage$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$58() {
  this.bFd = null;
  this.bF5 = null;
  this.bF6 = false;
  this.bFe = null;
  this.bFf = false;
  this.bFi = null;
  this.bFb = null;
  this.bFc = false;
  this.bF7 = null;
  this.bF8 = false;
  this.bF9 = null;
  this.bFa = false;
  this.bFg = false;
  this.bFh = false;
  this.bFd = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bFi = "TwoFactorAuthUsage";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$58 as $c_Lpresto_TwoFactorAuthView$$anon$58 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$58.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$58;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$58() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$58 as $h_Lpresto_TwoFactorAuthView$$anon$58 };
$h_Lpresto_TwoFactorAuthView$$anon$58.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bFd;
});
$p.L = (function() {
  if ((!this.bF6)) {
    this.bF5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bF6 = true;
  }
  return this.bF5;
});
$p.O = (function() {
  if ((!this.bFf)) {
    this.bFe = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bFf = true;
  }
  return this.bFe;
});
$p.E = (function() {
  return this.bFi;
});
$p.t = (function() {
  if ((!this.bFc)) {
    this.bFb = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("tfa", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("sites", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("credentials", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bFc = true;
  }
  return this.bFb;
});
$p.M = (function() {
  if ((!this.bF8)) {
    this.bF7 = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002459.$c_Lpresto_TwoFactorAuthView$$anon$59(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002461.$c_Lpresto_TwoFactorAuthView$$anon$61())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002463.$c_Lpresto_TwoFactorAuthView$$anon$63())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bF8 = true;
  }
  return this.bF7;
});
$p.Q = (function() {
  if ((!this.bFa)) {
    this.bF9 = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002465.$c_Lpresto_TwoFactorAuthView$$anon$65();
    this.bFa = true;
  }
  return this.bF9;
});
$p.w = (function() {
  if ((!this.bFh)) {
    this.bFg = false;
    this.bFh = true;
  }
  return this.bFg;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee681) => ((p) => \u03b4scrutinee681.z5(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024.$m_Lpresto_types$TwoFactorAuthUsage$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$58 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$58, "presto.TwoFactorAuthView$$anon$58", ({
  SW: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$58 as $d_Lpresto_TwoFactorAuthView$$anon$58 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$58.js.map
